import { useParams } from 'react-router-dom';
import { filterXSS } from 'xss';

import AttendanceView from '../components/attendance/AttendanceView';
import AttendanceLayout from '../components/layout/AttendanceLayout';
import { AttendanceProvider, type AttendanceProviderProps } from '../context/AttendanceContext';
import { getUrlParams } from '../utils/url';

const Attendance = () => {
    const { classId } = useParams<{ classId: string }>();

    const { student_id: studentId = '', session_id: classSessionId = '' } = getUrlParams();

    const props: AttendanceProviderProps = {
        classId: filterXSS(classId),
        studentId: filterXSS(studentId),
        classSessionId: filterXSS(classSessionId)
    };

    if (!props.studentId && !props.classSessionId) {
        props.classSessionId = 'today';
    }

    return (
        <AttendanceProvider {...props}>
            <AttendanceLayout>
                <AttendanceView />
            </AttendanceLayout>
        </AttendanceProvider>
    );
};

export default Attendance;
